import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private activeRequests = new BehaviorSubject<number>(0);
  isVisible$ = this.activeRequests.pipe(
    map(count => count > 0)
  );

  show() {
    this.activeRequests.next(this.activeRequests.value + 1);
  }

  hide() {
    this.activeRequests.next(Math.max(0, this.activeRequests.value - 1));
  }
}
